<template>
  <svg class="x-icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.927 2.97476L7 3.29338L5.5 4.82965L5.854 7L4 5.97476L2.146 7L2.5 4.82965L1 3.29338L3.073 2.97476L4 1L4.927 2.97476Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
